export default __webpack_public_path__ + "static/media/3008.4deb67d0.jpg";